import { config } from "../../../config/config";

export function mediaUrl(image: string | null | undefined): string {
  if (!image) return "";
  if (/^(https?:|blob:|data:)/i.test(image)) return image;
  const origin = config.api_url.replace(/\/api\/v1\/?$/, "");
  return `${origin}${image.startsWith("/") ? image : `/${image}`}`;
}
